import { all, call, cancel, fork, put, select, take, takeEvery } from 'redux-saga/effects';

import { addDynamicSaga, store as getStore, setDynamicReducers } from '../store';
import createReducer from '../reducers';
import { selectors } from '../selectors';

import actions from './actions';
import types from './types';

export function* onAddSaga(sagas) {
    if (Array.isArray(sagas)) {
        return yield all(sagas);
    }
    return yield call(sagas);
}

export function* addSaga(action) {
    const { name, sagas, initAction } = action.payload;
    const store = yield call(getStore);

    const storeState = yield select(selectors.getStore, name);
    if (!storeState) {
        yield take(types.AFTER_ADD_REDUCER);
    }

    if (store.dynamicSagas[name]) {
        yield cancel([store.dynamicSagas[name]]);
    }
    yield call(addDynamicSaga, name, yield fork(onAddSaga, sagas));

    if (initAction) {
        yield put(initAction);
    }
}

export function* removeSaga(action) {
    const name = action.payload;
    const store = yield call(getStore);

    if (store.dynamicSagas[name]) {
        yield cancel([store.dynamicSagas[name]]);
        delete store.dynamicSagas[name];
    }
}

export function* addReducer(action) {
    const { name, reducer } = action.payload;
    const store = yield call(getStore);

    if (!store.dynamicReducers[name]) {
        const newDynamicReducers = {
            ...store.dynamicReducers,
            [name]: reducer,
        };
        const combinedReducers = yield call(createReducer, newDynamicReducers);
        yield call(store.replaceReducer, combinedReducers);
        yield call(setDynamicReducers, newDynamicReducers);
    }

    yield put(actions.afterAddReducer());
}

export function createWatcherHelper(rawActions) {
    return function*(actionData) {
        const actions = Array.isArray(rawActions) ? rawActions : [rawActions];
        for (const action of actions) {
            if (typeof action === 'function') {
                yield call(action, actionData);
            } else {
                yield put(action);
            }
        }
    };
}

export const createWatcher = (type, actions = []) => takeEvery(type, createWatcherHelper(actions));

export function* removeReducer(action) {
    const name = action.payload;
    const store = yield call(getStore);

    if (store.dynamicReducers[name]) {
        const { [name]: ignoreMe, ...newDynamicReducers } = store.dynamicReducers;
        const combinedReducers = yield call(createReducer, newDynamicReducers);
        yield call(store.replaceReducer, combinedReducers);
        yield call(setDynamicReducers, newDynamicReducers);
    }
}

export default [
    takeEvery(types.ADD_SAGA, addSaga),
    takeEvery(types.REMOVE_SAGA, removeSaga),
    takeEvery(types.ADD_REDUCER, addReducer),
    takeEvery(types.REMOVE_REDUCER, removeReducer),
];
